export enum InteractionName {
  trialHubRendered = "trial_hub_rendered",
  trialHubClosed = "trial_hub_closed",
  trialHubActionClicked = "trial_hub_action_clicked",
  trialHubUpgradeCTAClicked = "trial_hub_upgrade_cta_clicked",
}

export const UserInteractionEvent =
  "web_analytics.tracking.user_interaction.UserInteractionEvent";
